<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    :value="showMenu"
    @input="onInput"
  >
    <template v-slot:activator="{}">
      <Button
        plain
        icon="mdi-menu-down"
        iconPosition="right"
        color="grey"
        :class="buttonClass"
        :text="$t('home.teams_activity.columns')"
        @click="showMenu = !showMenu"
      />
    </template>
    <v-card>
      <v-card-text
        class="columns-header px-4 py-2 caption blue-grey--text text--darken-2"
        v-if="limitActiveColumns"
      >
        {{
          $t('home.selected_of', {
            count: usedColumns,
            limit: limitActiveColumns,
          })
        }}
      </v-card-text>
      <v-card-text class="columns-list p-0">
        <v-list>
          <v-list-item v-for="(header, i) in headers" dense :key="header.value">
            <v-checkbox
              dense
              class="mt-0 mb-n2"
              :disabled="isCheckboxDisabled(header.show)"
              :input-value="header.show"
              @change="handleColumnToggle($event, i)"
            >
              <template v-slot:label>
                <span class="caption blue-grey--text text--darken-2">{{
                  header.text
                }}</span>
              </template>
            </v-checkbox>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  name: 'ColumnsSelector',

  components: {
    Button,
  },

  props: {
    headers: {
      type: Array,
      required: true,
    },
    limitActiveColumns: {
      type: Number,
      required: false,
    },
    buttonClass: { type: String, default: '' },
    persistenceKey: { type: String, default: '' },
  },

  data() {
    return {
      showMenu: false,
    }
  },

  created() {
    this.retrieveInitialState()
  },

  computed: {
    usedColumns() {
      return this.headers.filter(h => h.show)?.length ?? 0
    },

    isCheckboxDisabled() {
      return show => {
        const hasLimit = Boolean(this.limitActiveColumns)

        const hasReachedLimit =
          hasLimit && this.usedColumns >= this.limitActiveColumns

        return (hasReachedLimit && !show) || (this.usedColumns === 1 && show)
      }
    },
  },

  watch: {
    headers: {
      handler() {
        this.persistState()
      },
      deep: true,
    },
  },

  methods: {
    onInput() {
      this.showMenu = !this.showMenu
      if (this.showMenu) return

      this.$emit('close')
    },

    handleColumnToggle(value, index) {
      this.$emit('toggleColumn', {
        index,
        value,
      })
    },

    persistState() {
      if (!this.persistenceKey) return

      const columns = this.headers
        .filter(header => header.show)
        .map(header => header.value)
        .join(',')

      localStorage.setItem(`${this.persistenceKey}__selectedColumns`, columns)
    },

    retrieveInitialState() {
      if (!this.persistenceKey) return

      const columns = localStorage.getItem(
        `${this.persistenceKey}__selectedColumns`
      )
      if (!columns) return

      const columnsArray = columns.split(',')

      this.$emit('setInitialColumns', columnsArray)
    },
  },
}
</script>

<style lang="scss" scoped>
.columns-list {
  max-height: 250px;
  overflow-y: scroll;
}
.columns-header {
  border-bottom: 1px solid $color-blue-grey-lighten2;
}
</style>
